import { Container, Grid, Paper, withStyles, Button } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import KeysTable from '../table/key';
import KeyForm from '../forms/key';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { REQUEST_KEYS } from '../../core/handlers.actions';

const styles = (theme: any) => ({
    root: { flrexGrow: 1, paddingTop: theme.spacing(4), paddingBottom: theme.spacing(4) },
    paper: { padding: theme.spacing(2), textAlign: 'center' as any, color: theme.palette.text.secondary }
});

interface Props {
    classes: any;
    currentUser:any;
    getKeys: () => void;
    keys:any;
}

interface State {
    isEditing: boolean;
    key: any;
}


class Keys extends Component<Props, State> {
    state: State = { isEditing: false, key: null};

    constructor(props: Props) {
        super(props);
        this.editHandler = this.editHandler.bind(this);
        this.reset = this.reset.bind(this);
        this.redirect = this.redirect.bind(this);
        this.props.getKeys();
    }

    public editHandler(id: any ) {
        this.setState({ ...this.state, isEditing: true, key:id });
    }

    public reset() {
        this.setState({ ...this.state, isEditing: false});
    }

    public redirect(){
        window.location.href = '/';
    }

    public render() {
        const { classes, currentUser} = this.props;
        const { isEditing, key } = this.state;

        return (
            <div>
                {currentUser.role !== 'admin' ?
                    <Container className={classes.root}>
                        <strong>You do not have the right permissions to render this view...</strong>
                        {this.redirect()}
                    </Container>
                    :
                    <Container className={classes.root}>
                        <h2>API KEYS</h2>
                        <Grid container spacing={1} direction="row" justify="flex-start" >
                            <Grid item xs={12} md={4}>
                                {isEditing ?
                                    <Paper className={classes.paper}>
                                        <KeyForm keyId={key} reset={this.reset}  />
                                    </Paper>
                                    :
                                    <Grid container >
                                        <Grid item>
                                            <Button variant="contained" onClick={() => this.editHandler(null)} color="primary" startIcon={<VpnKeyIcon />}>Add API Key</Button>
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <KeysTable  editKey={this.editHandler}/>
                            </Grid>
                        </Grid>
                    </Container>
                }
            </div>
        );
    }
}
const mapProps = (app: any) => ({ currentUser: app.rootReducer.user, keys: app.rootReducer.keys });
const mapDispatch = (dispatch: Dispatch) => ({
    getKeys: () => dispatch({type: REQUEST_KEYS})
});
export default connect(mapProps, mapDispatch)(withStyles(styles)(Keys));